import { DataGrid, type GridColDef } from '@shared/components';

import { ExamEventProctorListNoRowOverlay } from '../exam-event-proctor-list-no-row-overlay';

export interface ExamEventProctorDataGridRow {
  id: string;
  name: string;
  type: string;
}

export type ExamEventProctorDataGridColumn = GridColDef<ExamEventProctorDataGridRow>;

export interface ExamEventProctorDataGridProps {
  rows: ExamEventProctorDataGridRow[];
  columns?: ExamEventProctorDataGridColumn[];
}

const defaultColumns: ExamEventProctorDataGridColumn[] = [
  { field: 'name', headerName: 'ชื่อ-นามสกุล', flex: 1, sortable: false },
  { field: 'type', headerName: 'ประเภทผู้คุมสอบ', width: 240, sortable: false },
];

export default function ExamEventProctorDataGrid(props: Readonly<ExamEventProctorDataGridProps>) {
  const { rows, columns = defaultColumns } = props;
  return (
    <DataGrid
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
      rows={rows}
      columns={columns}
      rowHeight={48}
      slots={{ noRowsOverlay: ExamEventProctorListNoRowOverlay }}
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '124px',
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
      })}
    />
  );
}
